/**
 * An amount in the currency it was charged in.
 *
 * <p>Forints are written the Hungarian way, with no decimals when there are
 * none ("1 300 Ft"); euros keep their cents ("€12.50"). Anything else falls
 * back to the browser's own currency formatting. A missing amount is a dash,
 * never a zero - a zero is a real figure and would be read as one.
 */
export const money = (amount: number | string | null | undefined, currency?: string | null): string => {
    if (amount === null || amount === undefined || amount === '') return '—';
    const n = Number(amount);
    if (!Number.isFinite(n)) return '—';

    if (currency === 'HUF') {
        const whole = Number.isInteger(n);
        const digits = n.toLocaleString('en-GB', {
            minimumFractionDigits: whole ? 0 : 2,
            maximumFractionDigits: whole ? 0 : 2,
        });
        return `${digits.replace(/,/g, ' ')} Ft`;
    }
    if (!currency || currency === 'EUR') {
        return `${n < 0 ? '−' : ''}€${Math.abs(n).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
    try {
        return new Intl.NumberFormat('en-GB', { style: 'currency', currency }).format(n);
    } catch {
        return `${n.toFixed(2)} ${currency}`;
    }
};
